import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { ScrollContainerAttribute } from '../constants/telosair-interfaces';

type Props = {
  children: ReactNode;
  loading: boolean;
  setScrollContainerData: (value: ScrollContainerAttribute) => void;
  scrollContainerData: ScrollContainerAttribute;
};

/**
 * React compoennt for Scroll View.
 * @param props - Properties.
 * @returns Scroll view.
 */
export default function ScrollView(props: Props): ReactElement {
  const { children, loading, scrollContainerData, setScrollContainerData } = props;
  const [resized, setResized] = useState(true);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollContainerRef.current) {
      return;
    }
    const rect = scrollContainerRef.current?.getBoundingClientRect();
    const scrollData = { height: rect.height, loaded: true, width: rect.width };

    if (!loading && resized) {
      setScrollContainerData(scrollData);
      setResized(false);
    }
  }, [resized, loading, scrollContainerData]);

  useEffect(() => {
    if (!scrollContainerData.loaded && !resized) {
      setResized(true);
    }
  }, [scrollContainerData, resized]);

  /**
   * Function to handle event resize.
   */
  const handleResize = (): void => {
    setResized(true);
    setScrollContainerData({ loaded: false, height: null, width: null });
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="flex flex-1 flex-col relative" ref={scrollContainerRef}>
      {children}
    </div>
  );
}
